/** Popover: no arrow, radius lg, lg shadow. Header/body/footer carry their own padding; footer is sunken (sand.50). */
export const Popover = {
  baseStyle: {
    popper: { zIndex: "popover" },
    content: {
      bg: "surface.card",
      color: "text.primary",
      borderRadius: "lg",
      boxShadow: "lg",
      border: "none",
      w: "auto",
      _focusVisible: { boxShadow: "lg", outline: "none" },
      _focus: { boxShadow: "lg", outline: "none" },
    },
    arrow: { display: "none" },
    header: {
      px: 5,
      py: 4,
      borderBottom: "1px solid",
      borderColor: "border.default",
      fontFamily: "heading",
      fontWeight: 700,
      fontSize: "1rem",
    },
    body: { px: 5, py: 4 },
    footer: {
      px: 5,
      py: 3,
      bg: "sand.50",
      borderTop: "1px solid",
      borderColor: "border.default",
      borderBottomRadius: "lg",
    },
    closeButton: { borderRadius: "full", color: "text.muted", top: 3, right: 3, _hover: { bg: "sand.100" } },
  },
};
